import { FC, ReactNode } from "react";
import { Box } from "@chakra-ui/react";

export const DrawerSection: FC<{ children: ReactNode }> = ({ children }) => (
  <Box
    p="16px"
    borderRadius="10px"
    mb="24px"
    boxShadow="0px 6px 20px 0px rgba(0, 0, 0, 0.12);"
  >
    {children}
  </Box>
);
